<template>
  <div>
    <v-card class="mb-4" outlined :loading="loading">
      <v-card-text>
        <v-file-input
          v-if="!url && !urlTemp && !imagem"
          v-model="input_value"
          accept="image/*"
          :label="label"
          dense
          clearable
          outlined
          show-size
          @change="getPreview"
        >
        </v-file-input>
        <Cropper
          ref="cropper"
          class="cropper ma-0"
          v-if="urlTemp"
          :src="urlTemp"
          :stencil-props="{
            aspectRatio: 4 / 3,
          }"
        ></Cropper>
        <v-img v-if="url" :src="url" class="ma-0" :aspect-ratio="4 / 3"></v-img>
        <v-img v-if="imagem" :src="imagem.foto_url" class="ma-0" :aspect-ratio="4 / 3"></v-img>
      </v-card-text>
      <v-card-actions v-if="url || urlTemp || imagem">
        <v-spacer></v-spacer>
        <v-btn v-if="urlTemp" depressed small dark @click="cropImage" color="teal">
          <v-icon left>mdi-crop</v-icon>
          Cortar
        </v-btn>

        <span v-if="url">
          <v-btn depressed small dark @click="clearAll" color="red">
            <v-icon left>mdi-trash-can</v-icon>
            Limpar
          </v-btn>
          <v-btn class="mx-2" depressed small dark @click="uploadImage" color="primary">
            <v-icon left>mdi-send</v-icon>
            Enviar
          </v-btn>
        </span>

        <v-btn
          v-if="imagem"
          class="mx-2"
          @click="destroyFileConfirm(imagem)"
          depressed
          small
          dark
          color="red"
        >
          <v-icon left>mdi-trash-can</v-icon>
          Remover
        </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import { Cropper } from 'vue-advanced-cropper';
import { mapActions, mapState } from 'vuex';
import veiculoHttp from '@/services/http/resources/frota/veiculoHttp';
import toastMessage, { confirmDestroyAlert } from '@/services/util/alertService';

export default {
  name: 'InputImageCrop',
  components: { Cropper },
  props: {
    codigo: {
      require: true,
      type: String,
    },
    label: {
      require: true,
      type: String,
    },
  },
  data: () => ({
    loading: false,
    imagem: null,
    canvas: null,
    url: null,
    urlTemp: null,
    input_value: null,
  }),
  computed: {
    ...mapState('veiculo', ['data']),
  },
  created() {
    this.getImagem();
  },
  methods: {
    ...mapActions('veiculo', ['storeImagem', 'destroyImagem']),
    getImagem() {
      this.loading = true;
      veiculoHttp
        .showImage(this.data.id, this.codigo)
        .then(({ data: { data } }) => {
          this.imagem = data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getPreview() {
      if (this.input_value) {
        const fr = new FileReader();
        fr.readAsDataURL(this.input_value);
        fr.addEventListener('load', () => {
          this.urlTemp = fr.result;
        });
      } else {
        this.url = null;
        this.urlTemp = null;
        this.canvas = null;
      }
    },
    cropImage() {
      const { canvas } = this.$refs.cropper.getResult();
      this.canvas = canvas;
      this.cropedImage();
    },
    cropedImage() {
      this.url = this.canvas.toDataURL('image/jpeg');
      this.urlTemp = null;
    },
    clear() {
      this.canvas = null;
      this.url = null;
      this.urlTemp = null;
      this.input_value = null;
    },
    uploadImage() {
      if (this.canvas) {
        const form = new FormData();
        this.canvas.toBlob((blob) => {
          form.append('foto', blob);
          form.append('veiculo_id', this.data.id);
          form.append('codigo', this.codigo);
          this.loading = true;
          this.storeImagem(form)
            .then(() => {
              toastMessage.successSave('Upload efetuado com sucesso.');
              this.getImagem();
              this.clear();
            })
            .catch(() => toastMessage.errorSave('Erro ao enviar foto.'))
            .finally(() => {
              this.loading = false;
            });
        }, 'image/jpeg');
      }
    },
    clearAll() {
      this.clear();
      this.imagem = null;
    },
    destroyFileConfirm(item) {
      confirmDestroyAlert(this.label).then((result) => {
        if (result.value) {
          this.loading = true;
          this.destroyImagem({ veiculoId: item.veiculo_id, imagemId: item.id })
            .then(() => {
              toastMessage.successDestroy('Imagem excluída com sucesso');
              this.clearAll();
            })
            .catch(() => toastMessage.errorDestroy('Erro ao excluir imagem.'))
            .finally(() => {
              this.loading = false;
            });
        }
      });
    },
  },
  destroyed() {
    this.clearAll();
  },
};
</script>
